import {Directive, Input, OnDestroy, TemplateRef, ViewContainerRef} from '@angular/core';
import {UtilisateurCourantService} from '../../../services/utilisateurs/utilisateur-courant.service';
import {IfAuthorizedAbstractDirective} from './if-authorized-abstract.directive';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[ifAuthorizedExport]',
})
export class IfAuthorizedExportDirective extends IfAuthorizedAbstractDirective implements OnDestroy {
  constructor(
    viewContainerRef: ViewContainerRef,
    templateRef: TemplateRef<any>,
    utilisateurCourantService: UtilisateurCourantService,
  ) {
    super(viewContainerRef, templateRef, utilisateurCourantService);
    this.forExport();
  }

  @Input('ifAuthorizedExportElse') set ifAuthorizedExportElse(value: TemplateRef<any>) {
    this.elseTemplate = value;
  }

  ngOnDestroy(): void {
    this.unsubscribeAll();
  }

  @Input() set ifAuthorizedExport(value: string | number) {
    this.fonctionLogicielle = value;
  }
}
